class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();

    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
      .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener('change', this.debouncedOnChange.bind(this));

    if (document.readyState === "complete" || document.readyState === "loaded") {
      this.addParentElementEvents()
    } else {
      this.addParentElementEvents(100)
    }
  }

  addParentElementEvents(delay) {
    this.parentElement.addEventListener("scroll", this.handleParentElementScroll.bind(this))
    this.parentElement.querySelector(".drawer-scroll-top").addEventListener("click", () => {
      this.parentElement.scrollTop = 0;
    })
    setTimeout(() => {
      this.updateCartDiscountSlider()
    }, (delay || 10))
  }

  handleParentElementScroll() {
    const scrollingElement = this.closest("cart-drawer").querySelector(".drawer__footer-content");

    const topValue = -(scrollingElement.clientHeight / 2);

    if (scrollingElement.getBoundingClientRect().y <= topValue) {
      this.parentElement.classList.add("scrolling-manual")
    } else {
      this.parentElement.classList.remove("scrolling-manual")
      const cartFreeDelivery = document.querySelector("#cart__footer__information #cart-page-free-delivery")
      if (cartFreeDelivery) {
        cartFreeDelivery.style.display = "none"
      }
    }
  }

  onChange(event) {
    event.preventDefault()
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'cart-icon-bubble--mobile',
        section: 'cart-icon-bubble--mobile',
        selector: '.shopify-section'
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section'
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      }, {
        id: 'pdp-bulk-discount-bar',
        section: 'bulk-discount-bar',
        selector: '.discount-bulk-order'
      }
    ];
  }

  updateQuantity(line, quantity, name) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        this.classList.toggle('is-empty', parsedState.item_count === 0);

        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        if (parsedState.errors) {
          this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
          const lineItemError = document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`)
          lineItemError.textContent = parsedState.errors
          this.disableLoading();
          return false
        }

        this.getSectionsToRender().forEach((section => {
          const elementToReplace = document.getElementById(section.id)?.querySelector(section.selector) || document.getElementById(section.id);
          if (elementToReplace) {
            elementToReplace.innerHTML =
              this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
          }
        }));

        //this.updateLiveRegions(line, parsedState.item_count);
        const lineItem = document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`)) : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'))
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'))
        }
        this.disableLoading();

//        var freedelivery = parsedState.sections[Object.keys(parsedState.sections)[0]];
//        if(document.getElementById('cart-page-free-delivery')){
//          freedelivery = freedelivery.split('<div id="cart-page-free-delivery" class="free-delivery-bar">').pop();
//          freedelivery = freedelivery.split('<div class="free-delivery-bar__end hide"></div>').shift();
//          if(document.getElementById('cart-page-free-delivery')) document.getElementById('cart-page-free-delivery').innerHTML = freedelivery;
//          if(document.getElementById('product-page-free-delivery')) document.getElementById('product-page-free-delivery').innerHTML = freedelivery;
//        }
        this.addParentElementEvents()
      }).catch((e) => {
        console.log(e)
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
        this.disableLoading();
      });
  }

  // getComplementaryProductForm() {
  //   const formElement = document.createElement("form")

  //   formElement.innerHTML = `<input name="quantity" value="1" />
  //     <input name="id" value="${window.complementaryProduct.variants[0].id}" />
  //     <input name="properties[_complementary_product]" value="1" />
  //   `
  //   return formElement
  // }

  // handleComplementaryProduct(response) {
  //   const complementaryProductItem = response.items.find((item) => item.product_id == window.complementaryProduct.id && item.properties._complementary_product)
  //   const cxProProductItem = response.items.find((item) => item.product_id == window.cxProProduct.id)

  //   let original_total_price = response.original_total_price
  //   if (complementaryProductItem) {
  //     original_total_price -= complementaryProductItem.original_line_price
  //   }

  //   if (cxProProductItem) {
  //     original_total_price -= cxProProductItem.original_line_price
  //   }

  //   // if (original_total_price >= 50000 && !complementaryProductItem && (cxProProductItem || window.isCxProCustomer)) {
  //   //   this.addToCart(this.getComplementaryProductForm())
  //   //   .then((response) => {
  //   //     return this.updateQuantity(1, 1)
  //   //   })
  //   // } else if ((original_total_price < 50000 || (!cxProProductItem && !window.isCxProCustomer)) && complementaryProductItem) {
  //   //   document.querySelector(`[data-item-key="${complementaryProductItem.key}"]`).querySelector("cart-remove-button").click()
  //   // }
  // }

  addToCart(form) {
    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];

    const formData = new FormData(form);
    config.body = formData;

    return fetch(`${routes.cart_add_url}`, config)
    .then((response) => response.json())
  }

  updateLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
      const lineItemError = document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
      const quantityElement = document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
      lineItemError
        .querySelector('.cart-item__error-text')
        .innerHTML = window.cartStrings.quantityError.replace(
          '[quantity]',
          quantityElement.value
        );
    }

    this.currentItemCount = itemCount;
    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading() {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');
  }

  updateCartDiscountSlider() {
    function getWidthInNumber(element) {
      let width = getComputedStyle(element).width
      return width == "auto" ? "auto" : parseInt(width.replace("px", ""))
    }

    const progressBarCircle = this.parentElement.querySelector(".cart-drawer-cx-pro-widget--inner .section2__progressBarCircle")
    const cartSliderBar = this.parentElement.querySelector(".cart-drawer-cx-pro-widget--inner .free-delivery-bar__toolbar")
    const afterLength = window.getComputedStyle(cartSliderBar, "::after").width
    if (afterLength == "auto") {
      return setTimeout(this.updateCartDiscountSlider.bind(this), 50)
    }
    const cartAfterLength = parseInt(afterLength.replace("px", ""))
    progressBarCircle.style.left = cartAfterLength < 10 ? '0 px' : (cartAfterLength - 10) + 'px';

    const midIndicatoraLabel = document.querySelector('.cart-drawer-cx-pro-widget--inner .membership_pro_class_mid .discount_normal')
    if (midIndicatoraLabel) {
      midIndicatoraLabel.style.left = cartAfterLength < 10 ? '0px' : (cartAfterLength - (getWidthInNumber(midIndicatoraLabel) / 2) + "px")
    }

    const pdpProgressBarCircle = document.querySelector(".product_page_discount_percent .section2__progressBarCircle");
    if (pdpProgressBarCircle) {
      const reqPDPLength = window.getComputedStyle(
      document.querySelector('.product_page_discount_percent .free-delivery-bar__toolbar'), "::after").width
      pdpProgressBarCircle.style.left = reqPDPLength;
      const reqPDPAfterLength = parseInt(reqPDPLength.replace("px", ""))

      const productMidIndicatoraLabel = document.querySelector('.product_page_discount_percent .membership_pro_class_mid .discount_normal')
      if (productMidIndicatoraLabel) {
        productMidIndicatoraLabel.style.left = reqPDPAfterLength < 10 ? '0px' : (reqPDPAfterLength - (getWidthInNumber(productMidIndicatoraLabel) / 2) + "px")
      }
    }
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define('cart-note', class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
      }, 300))
    }
  });
};


var customTheme = {
}

// quantity_limit 
// function limitQuantity(input, maxQuantity) {
//   if (parseInt(input.value) > maxQuantity) {
//       input.value = maxQuantity; 
//   }
// }
